// Share block — copy-link button. The social links are plain anchors;
// this only handles the "copy link" affordance. No-ops when absent.

export function initShare() {
    document.querySelectorAll('[data-share]').forEach((share) => {
        if (share.dataset.shareReady === 'true') return;
        share.dataset.shareReady = 'true';

        const copyBtn = share.querySelector('[data-share-copy]');
        if (!copyBtn) return;

        const url = share.dataset.shareUrl || window.location.href;
        const copied = copyBtn.querySelector('[data-share-copied]');

        copyBtn.addEventListener('click', async () => {
            try {
                await navigator.clipboard.writeText(url);
            } catch (e) {
                // Fallback for older browsers / insecure contexts.
                const ta = document.createElement('textarea');
                ta.value = url;
                ta.style.position = 'fixed';
                ta.style.opacity = '0';
                document.body.appendChild(ta);
                ta.select();
                try { document.execCommand('copy'); } catch (err) { /* noop */ }
                document.body.removeChild(ta);
            }

            if (copied) {
                copied.hidden = false;
                copyBtn.classList.add('is-copied');
                clearTimeout(copyBtn._copyTimer);
                copyBtn._copyTimer = setTimeout(() => {
                    copied.hidden = true;
                    copyBtn.classList.remove('is-copied');
                }, 2000);
            }
        });
    });
}
